import "../../../../content/projects/mkb/mkb.css";
import * as React from 'react';
export default {
  React
};